export default __webpack_public_path__ + "static/media/1845.e5017dbb.png";